import HeroCarousel from "./components/HeroCarousel";
import CategoryEntries from "./components/CategoryEntries";
import FeaturedWorks from "./components/FeaturedWorks";
import HomeIntro from "./components/HomeIntro";
import LatestNews from "./components/LatestNews";

export default function Home() {
  return (
    <>
      <HeroCarousel />
      <CategoryEntries />
      <FeaturedWorks />
      <HomeIntro />
      <LatestNews />
    </>
  );
}